import { AfterViewInit, Directive, ElementRef, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { filter, fromEvent, Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective implements AfterViewInit, OnDestroy {
  @Output() clickOutside = new EventEmitter<any>();
  private documentClickSubscription: Subscription | undefined;

  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngAfterViewInit() {
    this.documentClickSubscription = fromEvent(this.document, 'click')
      .pipe(
        filter((event: any) => {
          return !this.isInside(event.target as HTMLElement);
        })
      )
      .subscribe((event: any) => {
        this.clickOutside.emit(event);
      });
  }

  private isInside(elementToCheck: HTMLElement): boolean {
    // return elementToCheck === this.element.nativeElement || this.element.nativeElement.contains(elementToCheck);
    return this.element.nativeElement.contains(elementToCheck);
  }

  ngOnDestroy() {
    this.documentClickSubscription?.unsubscribe();
  }
}
